// extracted by mini-css-extract-plugin
export default {"background":"normalimg_background__Z4QLv"};